/* Motherhood page: food-plate interaction + add-to-cart.
   Uses the theme's own header and cart; no custom header code. */
(function () {
  var page = document.querySelector('.mm-page');
  if (!page) return;

  function pick(g, scroll) {
    page.querySelectorAll('.bowl').forEach(function (b) {
      b.setAttribute('aria-pressed', b.dataset.g === g);
    });
    page.querySelectorAll('.groups li').forEach(function (l) {
      l.classList.toggle('on', l.id === 'g-' + g);
    });
    var row = document.getElementById('g-' + g);
    if (scroll && row && window.matchMedia('(max-width:860px)').matches) {
      row.scrollIntoView({ block: 'nearest', behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
    }
  }

  var plate = page.querySelector('.plate');
  if (plate) plate.addEventListener('click', function (e) {
    var b = e.target.closest('.bowl'); if (b) pick(b.dataset.g, true);
  });
  var groups = page.querySelector('.groups');
  if (groups) groups.addEventListener('click', function (e) {
    var b = e.target.closest('.gname'); if (b) pick(b.dataset.g, false);
  });

  function updateThemeCart(count) {
    document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], .mm-cart-count, .cart-count, .mm-count').forEach(function (el) {
      el.textContent = count;
    });
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  page.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b || b.disabled) return;
    var st = b.nextElementSibling;
    b.disabled = true; b.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.dataset.add, quantity: 1, properties: { _source: 'motherhood' } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (st) { st.className = 'status'; st.innerHTML = 'Added to cart · <a href="/cart">View cart</a>'; }
      return fetch('/cart.js').then(function (c) { return c.json(); }).then(function (c) { updateThemeCart(c.item_count); });
    }).catch(function () {
      if (st && st.textContent.indexOf('Added') !== 0) { st.className = 'status err'; st.textContent = 'Couldn’t add. Try again or order on WhatsApp.'; }
    }).then(function () {
      b.disabled = false; b.removeAttribute('aria-busy');
    });
  });
})();
